import React, {Component} from 'react';
import Navigation from './Navigation';
import Footer from './Footer';
import ModalAddDashboard from './modals/ModalAddDashboard';
import ModalDeleteDashboard from './modals/ModalDeleteDashboard';
import { Container, Table, Button } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTable } from "@fortawesome/free-solid-svg-icons";
import { /*GET_DASHBOARDS,*/ GET_DASHBOARDS_BY_ORG_ID, CREATE_DASHBOARD, DELETE_DASHBOARD, GET_ORGS } from '../queries';
import { Query, withApollo, WithApolloClient } from 'react-apollo';
import { withToastManager } from 'react-toast-notifications';
import { withRouter } from 'react-router-dom';
import assign from 'lodash/assign';
import moment from 'moment';
// import {ROLE_ADMIN, ROLE_SUPER_ADMIN} from './auth/Auth';

class DashboardList extends Component<WithApolloClient<any>, any> {
  refetchData:any;

  constructor(props: any) {
    super(props);

    this.onCreateDashboard = this.onCreateDashboard.bind(this);
    this.onAddDashboard = this.onAddDashboard.bind(this);
    this.onHandleCloseAddDashboardModal = this.onHandleCloseAddDashboardModal.bind(this);
    this.onDeleteDashboard = this.onDeleteDashboard.bind(this);
    this.onHandleCloseDeleteDashboardModal = this.onHandleCloseDeleteDashboardModal.bind(this);

    this.state = {
      showAddDashboardModal: false,
      showDeleteDashboardModal: false,
      selectedDashboard: null,
      orgs: null
    };
  }

  componentDidMount() {
    if(this.props.currentUser) {
      this.getAllOrgs();
    }
  }

  async getAllOrgs() {
    const { client } = this.props;
    return client.mutate({
      mutation: GET_ORGS,
      //variables: dashboardData,
      optimisticResponse: null
    }).then((result:any) => {
      this.setState({orgs: result.data.syncarto_app_org});
    });
  }

  showDeleteDashboardModal(dashboardInstance:any) {
    this.setState((previousState:any) => ({
      ...previousState,
      selectedDashboard: dashboardInstance,
      showDeleteDashboardModal: true
    }));
  }

  renderDashboardListElements(dashboardData:any) {
    if (dashboardData && dashboardData.length > 0) {
      const dashboardRows = dashboardData.map((dashboard:any) => {
        return (
          <tr key={dashboard.id}>
            <td><a href={`/${dashboard.id}`}>{dashboard.name}</a></td>
            <td>{dashboard.org && dashboard.org.name ? dashboard.org.name : "Unknown Organization"}</td>
            <td>{moment(dashboard.created_at).format('LLL')}</td>
            <td>{moment(dashboard.updated_at).format('LLL')}</td>
            <td><Button variant="danger" onClick={() => this.showDeleteDashboardModal(dashboard)}>Delete</Button></td>
          </tr>
        );
      });
      return (
        <Table variant="dark" className="mt-2">
          <thead>
            <tr>
              <th>Dashboard Name</th>
              <th>Organization</th>
              <th>Created Date</th>
              <th>Last Updated</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            {dashboardRows}
          </tbody>
        </Table>
      );
    } else {
      return (
        <Table variant="dark" className="mt-2">
          <tbody>
            <tr><td className="text-center">No dashboards found</td></tr>
          </tbody>
        </Table>
      );
    }
  }

  onAddDashboard() {
    this.revealAddDashboardModal();
  }

  onHandleCloseDeleteDashboardModal() {
    this.setState((previousState:any) => ({
      ...previousState,
      selectedDashboard: null,
      showDeleteDashboardModal: false
    }));
  }

  async onDeleteDashboard(dashboardInstance: any) {
    const { currentUser, client } = this.props;

    let org_id = 0;

    if (currentUser) {
      org_id = currentUser.orgId;
    }

    console.log("Deleting dashboard instance:", dashboardInstance);

    await client.mutate({
      mutation: DELETE_DASHBOARD,
      variables: {id: dashboardInstance.id},
      optimisticResponse: null
    }).then((result:any) => {
      console.log("Delete dashboard result:", result);
      if (this.refetchData) {
        this.refetchData({org_id: org_id});
      }
    });

    this.onHandleCloseDeleteDashboardModal();
  }

  async onCreateDashboard(dashboardData:any) {
    const { client } = this.props;
    return client.mutate({
      mutation: CREATE_DASHBOARD,
      variables: {data: dashboardData},
      optimisticResponse: null
    }).then((result:any) => {
      // console.log(result);
      if (result && result.data && result.data.insert_syncarto_app_dashboard) {
        const returning_data = result.data.insert_syncarto_app_dashboard.returning[0];
        this.props.history.push(`/${returning_data.id}`);
      }
      this.sendMessage("Created dashboard!", 'success');
    });
  }

  revealAddDashboardModal() {
    this.setState({
      showAddDashboardModal: true
    });
  }

  onHandleCloseAddDashboardModal() {
    this.setState({
      showAddDashboardModal: false
    });
  }

  renderCreateDashboardButton() {
    return <Button variant="primary" key="create" className="float-right" onClick={this.onAddDashboard}>Create Dashboard <FontAwesomeIcon icon={faTable} /></Button>;
  }

  sendMessage(msg:string, type:string = 'success', options:object = {}) {
    const { toastManager } = this.props;
    let toastOptions = assign({
      appearance: type,
      autoDismiss: true,
      autoDismissTimeout: 3000,
      placement: 'bottom-center'
    }, options);
    toastManager.add(msg, toastOptions);
  }

  renderDashboardList() {
    const { showAddDashboardModal, orgs, showDeleteDashboardModal, selectedDashboard } = this.state;
    const { currentUser } = this.props;

    let org_id = 0;
    let org_name = '';
    let query = GET_DASHBOARDS_BY_ORG_ID;
    let queryVariables:any = {org_id: org_id};
    let showCreateDashboardOption = false;
    if (currentUser) {
      org_id = currentUser.orgId;
      queryVariables = {org_id: org_id};
      org_name = `Dashboards for ${currentUser.orgName}`;
      showCreateDashboardOption = true;
      /*if (currentUser.roleId === ROLE_ADMIN || currentUser.roleId === ROLE_SUPER_ADMIN ) {
        query = GET_DASHBOARDS;
        org_name = 'All Dashboards'
        queryVariables = null;
      }*/
    }

    return (
      <Container fluid className="dashboard_container">
        <div className="row no-gutters">
          <div className="w-75">
            <h2 className="text-left"> {org_name}</h2>
          </div>
          <div className="w-25">
            {showCreateDashboardOption &&
                  this.renderCreateDashboardButton()
            }
          </div>
        </div>
        <Query<any, any>
          query={query}
          variables={queryVariables}
          fetchPolicy="no-cache"
          notifyOnNetworkStatusChange={true}
        >{
          ({data, loading, error, refetch, networkStatus}) => {
            if (networkStatus === 4) return <div className="text-center">Refetching!</div>;
            if (loading || !data) {
              return (<div className="text-center">Loading...</div>);
            }
            if (error) {
              console.error(error);
              return (<div className="text-center">Error!</div>);
            }
            this.refetchData = refetch;
            const dashboards = data && data.syncarto_app_dashboard ? data.syncarto_app_dashboard : null;
            return this.renderDashboardListElements(dashboards);
          }
          }
        </Query>
        <ModalAddDashboard
          show={showAddDashboardModal}
          onHandleClose={this.onHandleCloseAddDashboardModal}
          onCreateDashboard={this.onCreateDashboard}
          orgs={orgs}
          currentUser={currentUser}
        />
        <ModalDeleteDashboard
          show={showDeleteDashboardModal}
          onHandleClose={this.onHandleCloseDeleteDashboardModal}
          onDeleteDashboard={this.onDeleteDashboard}
          dashboardInstance={selectedDashboard}
        />
        </Container>
    )
  }

  renderNavigation() {
    const { currentUser } = this.props;
    // console.log("Rerendering dashboard list");

    let navigationElement;
    if (!currentUser) {
      navigationElement =
        <Navigation
          currentUser={currentUser}
          showDashboardOptions={false}
          showCreateDashboardOption={false}
          onCreateDashboard={this.onAddDashboard}
          userOrgs={this.props.userOrgs}
          refreshAllCredentials={this.props.refreshAllCredentials}
        />;
    } else {
      navigationElement =
        <Navigation
          currentUser={currentUser}
          showDashboardOptions={false}
          showCreateDashboardOption={true}
          onCreateDashboard={this.onAddDashboard}
          userOrgs={this.props.userOrgs}
          refreshAllCredentials={this.props.refreshAllCredentials}
        />;
    }
    return navigationElement;
  }  
  
  render() {
    const { currentUser, isLoading } = this.props;

    let navigationElement = this.renderNavigation();
    let containerElement;

    if (!isLoading) {
      if (!currentUser) {
        containerElement = <Container fluid className="dashboard_container">
          <h2 className="text-center">Please Login to see Dashboards</h2>
        </Container>;
      } else {
        containerElement = this.renderDashboardList();
      }
    } else {
      containerElement = <Container fluid className="dashboard_container">
        <h2 className="text-center">Loading Dashboards</h2>
      </Container>;
    }

    return (
      <div>
        {navigationElement}
        {containerElement}
      </div>
    );
  }
}

export default withApollo<any, any>(withToastManager(withRouter(DashboardList)));
